var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/minus-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9012 16.206H12.071M27.7314 16.206C27.7314 22.6927 22.4729 27.9513 15.9861 27.9513C9.4993 27.9513 4.24072 22.6927 4.24072 16.206C4.24072 9.71918 9.4993 4.4606 15.9861 4.4606C22.4729 4.4606 27.7314 9.71918 27.7314 16.206Z",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.381f39b7ce400c9da5d55d49d195a74c.svg";
export { ForwardRef as ReactComponent };